import React from 'react';
import './Fruits.css'
import avacado from '../../images/fruits_avacado.jpg';
import grapes from '../../images/fruits_grapes.jpeg';
import pear from '../../images/fruits_pears.jfif';
import apple from '../../images/fruits_apples.jpg';

function Fruits() {
    return (
        <section>
            <div className="fruits-row">
                {/* <img src={avacado} alt="" />
                <img src={grapes} alt="" />
                <img src={pear} alt="" />
                <img src={apple} alt="" /> */}
                <div className="fruits-images-wrapper">
                    <div className="fruits-image  img-1"></div>
                    <div className="fruits-image  img-2"></div>
                    <div className="fruits-image  img-3"></div>
                    <div className="fruits-image  img-4"></div>
                </div>
                <div className="fruits-text">
                    <div dir="auto">
                        <h2>תמונות לרקע paralax</h2>
                    </div>
                    <div>
                        <div>
                            <div className="parallex-circle">
                                Paralax<br/>
                                Demo
                            </div>
                        </div>
                        <div dir="auto">
                            כשגוללים ב- one pager , נהוג לתת צבע רקע שונה לעמודים, כדי שהגולש יבחין שעבר עמוד.<br />
                            (לכן זה מה שקורה כאן). בהחלפות העמודים אפשר לפתוח רווחים ולשתול את הרקעים מאחור,<br />
                            כאמור, בקצב גלילה שונה. נותן תחושת תלת ממד והאתר נראה עדכני כזה והיי-טקי.
                        </div>
                    </div>
                </div>
            </div>

        </section>

    )
}

export default Fruits
